import React, { FunctionComponent } from 'react';

import Cta from '@gojob/ui-bits/Cta';
import useTheme from '@gojob/ui-bits/styles/useTheme';

export type ButtonProps = {
  href?: string;
};

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();
  return {
    root: {
      width: '100%',
      alignSelf: 'center',
      boxSizing: 'border-box',
      maxWidth: breakpoint.values.sm,
      margin: spacing(6, 0, 0),
    },
  };
};

const Button: FunctionComponent<ButtonProps> = (props) => {
  const { href } = props;
  const classes = useStyles();

  return (
    <Cta as="a" css={classes.root} href={href}>
      Accéder à Mon Cash
    </Cta>
  );
};

export default Button;
